import { PopupComponents } from '@/components/popup/PopupComponents';
import download_ios_pt from '@/assets/images/download_ios_pt.png';
import classNames from 'classnames';

const ApplePopup = ({ isOpen, closeModal }) => {
  return (
    <PopupComponents
      isOpen={isOpen}
      closeModal={() => {
        closeModal(false);
      }}
      direction="BtoT"
      dialogClassName="z-[1000] h-screen"
      classNameStr={classNames(
        'w-full bottom-0   !bg-transparent rounded-t-3xl  '
      )}
    >
      <div className="p-5 relative">
        <img className="" src={download_ios_pt} alt="" />
        <i
          onClick={() => closeModal(false)}
          className=" w-7 h-7 inline-block rounded-full absolute top-8 right-8"
        ></i>
      </div>
    </PopupComponents>
  );
};

export default ApplePopup;
